import { getIp } from '@/api/trace'
import browserCheck from '@/utils/checkBrowser'
import { extendUA } from '@/utils/extend-ua'

const app = {
  state: {
    clientIp: '',
    browser: browserCheck.browser, // 浏览器（微信、支付宝等）
    system: browserCheck.system, // 手机操作系统
    isIlisten: browserCheck.isIlisten, // 是否在口袋故事app中
    ilistenCaller: _getIlistenCaller(),
    ilistenPrdVer: _getIlistenPrdVer(),
    ilistenChannel: extendUA.ilistenMarketChannel,
  },
  mutations: {
    SET_CLIENTIP: (state, clientIp) => {
      state.clientIp = clientIp
    },
  },
  actions: {
    async getIp({ commit }) {
      try {
        let ipInfo = await getIp()
        commit('SET_CLIENTIP', ipInfo.ip)
      } catch (e) {
        console.log(e)
      }
    },
  }
}

function _getIlistenCaller() {
  const defaultCaller = '1002'
  if (!browserCheck.isIlisten) return defaultCaller
  let ua = window.navigator.userAgent.toLocaleLowerCase()
  let reg = /\(\/ilisten_(.*)\)/i
  let match = ua.match(reg)
  if (!match) return defaultCaller
  let info = match[1].split('_')
  let caller = info[1]
  let prdVer = info[2]
  if (!caller || !prdVer) return defaultCaller
  return caller
}

function _getIlistenPrdVer() {
  const defaultPrdVer = '1.0.0'
  if (!browserCheck.isIlisten) return defaultPrdVer
  let ua = window.navigator.userAgent.toLocaleLowerCase()
  let reg = /\(\/ilisten_(.*)\)/i
  let match = ua.match(reg)
  if (!match) return defaultPrdVer
  let info = match[1].split('_')
  let caller = info[1]
  let prdVer = info[2]
  if (!caller || !prdVer) return defaultPrdVer
  return prdVer
}

export default app
